import React from "react";
import axios from "axios";
import "../../css/table.css";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { toArray, orderBy } from "lodash";
import Card from "../../components/Card/Card.jsx";
import { resetForm } from "../../ducks/Forms";
import Modal from "../../components/Modal/Modal.jsx";
import CompanyForm from "../../forms/CompanyForm.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import { db, keygen } from "../../services/firebase";
import NotificationSystem from "react-notification-system";
import Button from "../../elements/CustomButton/CustomButton.jsx";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import SweetSpinner from "../../components/SweetSpinner/SweetSpinner.jsx";
import { style as NotifyStyle } from "../../variables/Variables.jsx";
import { Grid, Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  faLock,
  faUnlock,
  faPencilAlt,
  faCog,
} from "@fortawesome/fontawesome-free-solid";

class Companies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: {},
      loading: false,
      companyModal: false,
      state: "",
      alert: null,
      _notificationSystem: null,
      targetCompany: null,
    };
  }

  componentDidMount() {
    this._fetch();
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  render() {
    return (
      <div className="main-content">
        {this.companyModal()}
        {this.state.alert}
        <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Button
                bsStyle="default"
                wd
                className="pull-right"
                style={{ marginBottom: 10 }}
                onClick={() => {
                  this.props.resetForm("CompanyForm");
                  this.setState({ companyModal: true, targetCompany: null });
                }}
              >
                Adicionar Empresa
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card
                content={
                  <ReactTable
                    columns={[
                      { Header: "Nome", accessor: "name" },
                      { Header: "Cidade", accessor: "city" },
                      { Header: "Estado", accessor: "state" },
                      { Header: "Usuários", accessor: "users" },
                      { Header: "Turnos", accessor: "totalShifts" },
                      {
                        Header: "Ações",
                        accessor: "",
                        Cell: ({ value }) => (
                          <div style={{ textAlign: "center" }}>
                            {value.id !== "hfxokzjvXbUpLiNn63zd" && (
                              <div>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`settings_${value.id}`}>
                                      Configurações
                                    </Tooltip>
                                  }
                                >
                                  <a
                                    className="btn btn-simple btn-default btn-icon"
                                    onClick={() =>
                                      this.props.history.push(
                                        `/company/${value.id}`
                                      )
                                    }
                                  >
                                    <FontAwesomeIcon
                                      className="text-dark"
                                      icon={faCog}
                                    />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`edit_${value.id}`}>
                                      Editar
                                    </Tooltip>
                                  }
                                >
                                  <a
                                    className="btn btn-simple btn-default btn-icon"
                                    onClick={() =>
                                      this.setState({
                                        targetCompany: value,
                                        companyModal: true,
                                      })
                                    }
                                  >
                                    <FontAwesomeIcon
                                      className="text-dark"
                                      icon={faPencilAlt}
                                    />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`switch_status_${value.id}`}>
                                      {value.active
                                        ? "Bloquear Acesso"
                                        : "Desbloquear Acesso"}
                                    </Tooltip>
                                  }
                                >
                                  <a
                                    className="btn btn-simple btn-default btn-icon"
                                    onClick={() =>
                                      this.lockUnlockCompanyAlert(value)
                                    }
                                  >
                                    {value.active ? (
                                      <FontAwesomeIcon
                                        className="text-dark"
                                        icon={faLock}
                                      />
                                    ) : (
                                      <FontAwesomeIcon
                                        className="text-dark"
                                        icon={faUnlock}
                                      />
                                    )}
                                  </a>
                                </OverlayTrigger>
                                {/* <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={(<Tooltip id={`remove_${value.id}`}>Remover</Tooltip>)}
                                                                >
                                                                    <a
                                                                        className="btn btn-simple btn-danger btn-icon"
                                                                        onClick={() => this.removeCompanyAlert(value.id)}
                                                                    >
                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                    </a>
                                                                </OverlayTrigger> */}
                              </div>
                            )}
                          </div>
                        ),
                      },
                    ]}
                    data={orderBy(toArray(this.state.companies), [
                      "name",
                      "asc",
                    ])}
                    onFetchData={this._fetch}
                    loading={this.state.loading}
                    defaultPageSize={10}
                    className="-striped -highlight"
                    previousText="Anterior"
                    nextText="Próximo"
                    loadingText="Carregando"
                    noDataText="Nenhum registro encontrado"
                    pageText="Página"
                    ofText="de"
                    rowsText="Registros"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }

  //Data handlers
  _fetch = () => {
    db.collection("companies").onSnapshot((querySnapshot) => {
      this.setState({ loading: true });
      let companies = {};
      if (querySnapshot.empty) {
        this.setState({ loading: false });
      }
      querySnapshot.forEach((company) => {
        companies[company.id] = {
          ...company.data(),
          shifts: null,
          totalShifts: 0,
        };

        db.collection("companies")
          .doc(company.id)
          .collection("shifts")
          .onSnapshot((shiftSnapshot) => {
            let shiftArray = [];
            if (!shiftSnapshot.empty) {
              shiftSnapshot.forEach((shift) => {
                shiftArray.push({ id: shift.id, ...shift.data() });
              });
            }
            //totalShifts is a facade
            companies[company.id].shifts = shiftArray;
            companies[company.id].totalShifts = shiftArray.length || 0;
            this.setState({ loading: false, companies });
          });
      });
    });
  };

  _set = (values) => {
    this.setState({ companyModal: false });
    this.waitAlert("Adicionando empresa", true);
    const id = keygen();
    const { name, city, state } = values;
    db.collection("companies")
      .doc(id)
      .set({ name, city, id, state: state.value, users: 0, active: true })
      .then(() => {
        this.hideAlert();
        this.notify("Empresa adicionada", "success");
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao adicionar empresa", "error");
      });
  };

  _update = (id) => (values) => {
    this.setState({ companyModal: false });
    this.waitAlert("Atualizando dados", true);
    const { name, city, state } = values;

    db.collection("companies")
      .doc(id)
      .update({
        name,
        city,
        state: typeof state === "object" ? state.value : state,
      })
      .then(() => {
        this.hideAlert();
        this.notify(`${name} atualizada`, "success");
      })
      .catch((e) => {
        this.hideAlert();
        this.notify(`Erro ao atualizar ${name}`, "error");
      });
  };

  // _remove = id => {
  //     this.hideAlert()
  //     this.waitAlert('Removendo empresa, aguarde', false)

  //     const PromiseStack = []
  //     const ref = db.collection('companies').doc(id)
  //     const targets = 'shifts_indicators_lines_places_products_results_tables'.split('_')

  //     //remove users
  //     db.collection('users').where('company', '==', id).get()
  //         .then(snap => {
  //             if (!snap.empty) {
  //                 snap.forEach(s => PromiseStack.push(db.collection('users').doc(s.id).delete()))
  //             }

  //             //remove everything else
  //             targets.map(target => (
  //                 ref.collection(target).get()
  //                     .then(snap => {
  //                         if (!snap.empty) {
  //                             snap.forEach(s => PromiseStack.push(ref.collection(target).doc(s.id).delete()))
  //                         }
  //                     })
  //             ))

  //         })
  //         .catch(e => {
  //             this.hideAlert()
  //             this.notify('Erro ao remover os usuários.', 'error')
  //         })

  //     Promise.all(PromiseStack)
  //         .then(() => {
  //             ref.delete()
  //                 .then(() => {
  //                     this.hideAlert()
  //                     this.notify('Empresa removida.', 'success')
  //                 })
  //                 .catch(e => {
  //                     this.hideAlert()
  //                     this.notify('Erro ao remover a empresa.', 'error')
  //                 })
  //         })
  //         .catch(e => {
  //             this.hideAlert()
  //             this.notify('Erro ao remover dependências.', 'error')
  //         })
  // }

  _lockAccounts = (id) => {
    this.hideAlert();
    this.waitAlert("Bloqueando, aguarde", false);

    const FirestoreStack = [];
    const AuthStack = [];

    db.collection("companies")
      .doc(id)
      .update({ active: false })
      .then(() => {
        db.collection("users")
          .where("company", "==", id)
          .get()
          .then((users) => {
            if (users.empty) {
              this.hideAlert();
              this.notify(
                "Empresa bloqueada. As alterações podem demorar até 5 minutos para surtirem efeito.",
                "success"
              );
            } else {
              users.forEach((user) => {
                FirestoreStack.push(
                  db
                    .collection("users")
                    .doc(user.id)
                    .update({ active: false })
                    .catch((e) => console.log(e))
                );

                AuthStack.push(
                  axios
                    .put(
                      "https://us-central1-integrar-5ee17.cloudfunctions.net/lockAccount",
                      { id: user.id }
                    )
                    .catch((e) => console.log(e))
                );
              });

              Promise.all(FirestoreStack)
                .then(() => {
                  Promise.all(AuthStack)
                    .then(() => {
                      this.hideAlert();
                      this.notify(
                        "Empresa bloqueada. As alterações podem demorar até 5 minutos para surtirem efeito.",
                        "success"
                      );
                    })
                    .catch((e) => {
                      this.hideAlert();
                      this.notify("Erro ao bloquear a empresa.", "danger");
                    });
                })
                .catch((e) => {
                  this.hideAlert();
                  this.notify("Erro ao bloquear a empresa.", "danger");
                });
            }
          })
          .catch((e) => {
            this.hideAlert();
            this.notify("Erro ao bloquear a empresa.", "danger");
          });
      })
      .catch((e) => {
        this.hideAlert();
        this.notify("Erro ao bloquear a empresa.", "danger");
      });
  };

  _unlockAccounts = (id) => {
    this.hideAlert();
    this.waitAlert("Desbloqueando, aguarde", false);

    const FirestoreStack = [];
    const AuthStack = [];

    db.collection("companies")
      .doc(id)
      .update({ active: true })
      .then(() => {
        db.collection("users")
          .where("company", "==", id)
          .get()
          .then((users) => {
            if (users.empty) {
              this.hideAlert();
              this.notify(
                "Empresa desbloqueada. As alterações podem demorar até 5 minutos para surtirem efeito.",
                "success"
              );
            } else {
              users.forEach((user) => {
                FirestoreStack.push(
                  db
                    .collection("users")
                    .doc(user.id)
                    .update({ active: true })
                    .catch((e) => console.log(e))
                );

                AuthStack.push(
                  axios
                    .put(
                      "https://us-central1-integrar-5ee17.cloudfunctions.net/unlockAccount",
                      { id: user.id }
                    )
                    .catch((e) => console.log(e))
                );
              });

              Promise.all(FirestoreStack)
                .then(() => {
                  Promise.all(AuthStack)
                    .then(() => {
                      this.hideAlert();
                      this.notify(
                        "Empresa desbloqueada. As alterações podem demorar até 5 minutos para surtirem efeito.",
                        "success"
                      );
                    })
                    .catch((e) => {
                      this.hideAlert();
                      this.notify("Erro ao desbloquear a empresa.", "danger");
                    });
                })
                .catch((e) => {
                  this.hideAlert();
                  this.notify("Erro ao desbloquear a empresa.", "danger");
                });
            }
          })
          .catch((e) => {
            this.hideAlert();
            this.notify("Erro ao desbloquear a empresa.", "danger");
          });
      })
      .catch((e) => {
        this.hideAlert();
        this.notify("Erro ao desbloquear a empresa.", "danger");
      });
  };

  //Notifications
  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: null,
      message: <b>{message}</b>,
      level,
      position: "tr",
      autoDismiss: 4,
    });
  };

  //SweetAlerts
  hideAlert = () => this.setState({ alert: null });

  removeCompanyAlert = (idToRemove) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block" }}
          title="Tem certeza?"
          onConfirm={() => this._remove(idToRemove)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="default"
          confirmBtnText="Continuar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Todos os dados da empresa e de seus usuários serão removidos.
        </SweetAlert>
      ),
    });
  };

  lockUnlockCompanyAlert = (company) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block" }}
          title="Tem certeza?"
          onConfirm={() =>
            company.active
              ? this._lockAccounts(company.id)
              : this._unlockAccounts(company.id)
          }
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="default"
          cancelBtnBsStyle="warning"
          confirmBtnText="Continuar"
          cancelBtnText="Cancelar"
          showCancel
        >
          {company.active
            ? "Todos os usuários da empresa perderão o acesso ao sistema. Enquanto uma empresa estiver bloqueada, não será possível criar novos usuários relacionados a ela."
            : "Todos os usuários da empresa poderão acessar o sistema. Enquanto uma empresa estiver desbloqueada, será possível criar novos usuários relacionados a ela."}
        </SweetAlert>
      ),
    });
  };

  waitAlert = (title, showSpinner) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block" }}
          title={title}
          onConfirm={() => null}
          showConfirm={false}
        >
          {showSpinner ? <SweetSpinner /> : null}
        </SweetAlert>
      ),
    });
  };

  //Conditional rendering
  companyModal = () => {
    const { targetCompany } = this.state;
    return (
      <Modal
        title={targetCompany ? "Atualizar empresa" : "Adicionar empresa"}
        isOpen={this.state.companyModal}
        content={
          <CompanyForm
            initialValues={this.state.targetCompany}
            onSubmit={(values) => {
              targetCompany
                ? this._update(targetCompany.id)(values)
                : this._set(values);
            }}
            handleCancel={() => this.setState({ companyModal: false })}
          />
        }
      />
    );
  };
}

export default connect(null, { resetForm })(Companies);



// WEBPACK FOOTER //
// ./src/views/Companies/Companies.jsx